var $3bf9ad93c1aad52f$exports = {};
$3bf9ad93c1aad52f$exports = {
    "Clear search": `I\u{161}valyti ie\u{161}k\u{105}`
};


export {$3bf9ad93c1aad52f$exports as default};
//# sourceMappingURL=lt-LT.mjs.map
